import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Interaccion/Create',
  documento: 'crm',
  filas: ['144'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/InteraccionController.cs',
} satisfies RutaProd;
